import * as tslib_1 from "tslib";
import { Effect, Actions, ofType } from '@ngrx/effects';
import { HttpEventType } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, withLatestFrom, map } from 'rxjs/operators';
import { FileService } from 'src/app/core/file.service';
import { SocketGateway } from 'src/app/network/gateway/socket.gateway';
import { UploadGateway } from 'src/app/network/gateway/upload.gateway';
import { ChatDispatchers } from '../chats/chat.dispatchers';
import { UIDispatchers } from '../ui/ui.dispatchers';
import { SetChat, GetSubChats } from 'src/models/IChat';
import { ERROR_NOT_IMAGE, FILE_SIZE_EXCEEDED, MessageTypes, NOT_SUPPORTED_FILE_TYPE, NO_FILE_NAME, GROUP, PageDirection, UPDATE_GROUP_REF } from 'src/models/constants';
import { SubGroupUiDispatchers } from './subGroupsUI.dispatchers';
import * as isEqual from 'lodash.isequal';
import { SubChatsService } from 'src/app/+merchant/+dashboard/sub-chats/sub-chats.service';
export class SubGroupUiEffects {
    constructor(actions$, _chatDispatchers, _socketGateway, _uiDispatchers, _subGroupUiDispatchers, _fileService, _uploadGateway, subChatsService, _store) {
        this.actions$ = actions$;
        this._chatDispatchers = _chatDispatchers;
        this._socketGateway = _socketGateway;
        this._uiDispatchers = _uiDispatchers;
        this._subGroupUiDispatchers = _subGroupUiDispatchers;
        this._fileService = _fileService;
        this._uploadGateway = _uploadGateway;
        this.subChatsService = subChatsService;
        this._store = _store;
        this.uploadSubGroupImage = this.actions$.pipe(ofType("UPLOAD_SUB_GROUP_IMAGE" /* UPLOAD_SUB_GROUP_IMAGE */), withLatestFrom(this._store
            .select(state => state.subGroupUiReducer.creationProcessSubChat)
            .pipe(distinctUntilChanged(isEqual)), this._store
            .select(state => state.subGroupUiReducer.selectedSubGroup)
            .pipe(distinctUntilChanged(isEqual)), this._store
            .select(state => state.uiReducer.enableSetTemplateBtn)
            .pipe(distinctUntilChanged(isEqual))), map(([val, creationSubGroup, updatedSubGroup, enableSetTemplateBtn]) => {
            const action = val;
            if (this.validateFile(action.selectedFile.file, 'image')) {
                this._fileService
                    .readFileAsArrayBuffer(action.selectedFile.file.localFile)
                    .then(fileAsArrayBuffer => {
                    let groupID = '';
                    if (!enableSetTemplateBtn) {
                        groupID = creationSubGroup
                            ? creationSubGroup.id
                            : updatedSubGroup && updatedSubGroup.id
                                ? updatedSubGroup.id
                                : action.selectedFile.chat.id;
                    }
                    this._uploadGateway
                        .uploadWithProgress(fileAsArrayBuffer, action.selectedFile.file.localFile.type, action.selectedFile.file.localFile.name, false, '', null, groupID, true, true, '', false, false, 0, '1x1')
                        .subscribe(event => {
                        if (event.type === HttpEventType.Response) {
                            const res = event.body;
                            let chat = {};
                            const photo = { id: res.file };
                            chat.id = creationSubGroup
                                ? creationSubGroup.id
                                : updatedSubGroup.id;
                            chat.photo = photo;
                            chat = Object.assign({}, chat, action.selectedFile.chat);
                            // this.subChatsService._currentPhotoUploaded.next(res);
                            this.subChatsService._wattingForUploadImage.next(false);
                            this.subChatsService.showEditSubGroupScreen(chat);
                            this._socketGateway.sendSocketMessage(new SetChat(chat, UPDATE_GROUP_REF));
                            // if (enableSetTemplateBtn) {
                            //   const id = chat.id;
                            //   const type = chat.type.toLocaleLowerCase();
                            //   const tempChat = { ...chat };
                            //   delete tempChat['id'];
                            //   this._uiDispatchers.setChatToTemplate(id, type, tempChat);
                            // }
                        }
                    }, error => {
                        console.log('Failed to upload subGroup image');
                    });
                });
            }
        }));
        this.afterSubGroupCreation = this.actions$.pipe(ofType("UI_UPLOAD_SUB_GROUP_PHOTO" /* UI_UPLOAD_SUB_GROUP_PHOTO */), map((action) => {
            this._chatDispatchers.chatInvalidated(action.createdSubGroup.id);
        }));
        this.getNextSubGroupPage = this.actions$.pipe(ofType("UI_SUB_GROUP_GET_NEXT_PAGE" /* UI_SUB_GROUP_GET_NEXT_PAGE */), withLatestFrom(this._store
            .select(state => state.subGroupUiReducer)
            .pipe(distinctUntilChanged(isEqual))), map(([val, subGroupUiState]) => {
            const action = val;
            const prevRequest = subGroupUiState.previousRequest;
            if (!(subGroupUiState.eop === prevRequest.eop &&
                PageDirection.NEXT === prevRequest.direction &&
                subGroupUiState.hash === prevRequest.hash)) {
                this._socketGateway.sendSocketMessage(new GetSubChats([GROUP], 0, subGroupUiState.hash, subGroupUiState.eop));
            }
            else {
                this._subGroupUiDispatchers.setStatusAsIdle();
            }
        }));
        this.getPrevSubGroupPage = this.actions$.pipe(ofType("UI_SUB_GROUP_GET_PREV_PAGE" /* UI_SUB_GROUP_GET_PREV_PAGE */), withLatestFrom(this._store
            .select(state => state.subGroupUiReducer)
            .pipe(distinctUntilChanged(isEqual))), map(([val, subGroupUiState]) => {
            const action = val;
            const prevRequest = subGroupUiState.previousRequest;
            if (!(subGroupUiState.sop === prevRequest.sop &&
                PageDirection.PREV === prevRequest.direction &&
                subGroupUiState.hash === prevRequest.hash)) {
                this._socketGateway.sendSocketMessage(new GetSubChats([GROUP], 1, subGroupUiState.hash, subGroupUiState.sop));
            }
            else {
                this._subGroupUiDispatchers.setStatusAsIdle();
            }
        }));
        this.afterSubGroupSectionSelection = this.actions$.pipe(ofType("UI_LIST_SUB_GROUP" /* UI_LIST_SUB_GROUP */), map((action) => {
            this._subGroupUiDispatchers.resetSubGroupPaging();
        }));
        this.afterSubChatResetPaging = this.actions$.pipe(ofType("UI_SUB_GROUP_RESET_PAGING" /* UI_SUB_GROUP_RESET_PAGING */), map((action) => {
            this._subGroupUiDispatchers.getNextSubGroupPage();
        }));
        this.setGroupChat = this.actions$.pipe(ofType("UI_SET_GROUP_CHAT" /* UI_SET_GROUP_CHAT */), withLatestFrom(this._store
            .select(state => state.subGroupUiReducer.file)
            .pipe(distinctUntilChanged(isEqual))), map(([val, file]) => {
            if (file && file !== null) {
                const action = val;
                const chat = Object.assign({}, file.chat, { id: action.data.chat_id });
                const evntObject = Object.assign({}, file);
                evntObject.chat = chat;
                this._subGroupUiDispatchers.uploadSubGroupImage(evntObject);
                // this._socketGateway.sendSocketMessage(new SetChat(chat, UPDATE_GROUP_REF));
            }
        }));
    }
    validateFile(selectedFile, specificValidType) {
        if (!selectedFile.localFile.name) {
            this._uiDispatchers.showPopup(NO_FILE_NAME);
            return false;
        }
        else if (!this._fileService.isMimeTypeValid(selectedFile.type, selectedFile.localFile.type)) {
            this._uiDispatchers.showPopup(NOT_SUPPORTED_FILE_TYPE);
            return false;
        }
        else if (!this._fileService.isFileSizeValid(MessageTypes.PHOTO, selectedFile.localFile.size)) {
            this._uiDispatchers.showPopup(FILE_SIZE_EXCEEDED);
            return false;
        }
        else if (specificValidType &&
            selectedFile.localFile.type.indexOf(specificValidType) === -1) {
            this._uiDispatchers.showPopup(ERROR_NOT_IMAGE);
            return false;
        }
        return true;
    }
}
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], SubGroupUiEffects.prototype, "uploadSubGroupImage", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], SubGroupUiEffects.prototype, "afterSubGroupCreation", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], SubGroupUiEffects.prototype, "getNextSubGroupPage", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], SubGroupUiEffects.prototype, "getPrevSubGroupPage", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], SubGroupUiEffects.prototype, "afterSubGroupSectionSelection", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], SubGroupUiEffects.prototype, "afterSubChatResetPaging", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], SubGroupUiEffects.prototype, "setGroupChat", void 0);
